import throttle from 'lodash.throttle';
import EE from '~/listenerEventService/EventEmitter';

export default class IdleListener extends EE implements IListener {
  timer: number;
  lastEventTS: number;
  updateLastEventTS = throttle(
    () => {
      this.lastEventTS = new Date().getTime();
    },
    100,
    { trailing: true, leading: true }
  );

  bindListeners = () => {
    document.addEventListener('mousedown', this.updateLastEventTS);
    document.addEventListener('mouseup', this.updateLastEventTS);
    document.addEventListener('mousemove', this.updateLastEventTS);
    document.addEventListener('scroll', this.updateLastEventTS);
    document.addEventListener('resize', this.updateLastEventTS);
    document.addEventListener('input', this.updateLastEventTS);
    document.addEventListener('keydown', this.updateLastEventTS);
    document.addEventListener('keyup', this.updateLastEventTS);
    document.addEventListener('select', this.updateLastEventTS);
  }

  unbindListeners = () => {
    document.removeEventListener('mousedown', this.updateLastEventTS);
    document.removeEventListener('mouseup', this.updateLastEventTS);
    document.removeEventListener('mousemove', this.updateLastEventTS);
    document.removeEventListener('scroll', this.updateLastEventTS);
    document.removeEventListener('resize', this.updateLastEventTS);
    document.removeEventListener('input', this.updateLastEventTS);
    document.removeEventListener('keydown', this.updateLastEventTS);
    document.removeEventListener('keyup', this.updateLastEventTS);
    document.removeEventListener('select', this.updateLastEventTS);
  }

  setTimer = () => {
    this.timer = window.setTimeout(() => {
      this.tick();

      this.setTimer();
    }, 1000);
  }

  unsetTimer = () => {
    clearTimeout(this.timer);
  }

  tick = () => {
    const currentTS = new Date().getTime();
    const diff = Math.floor((currentTS - this.lastEventTS) / 1000);

    if (diff > 0) {
      this.emit('analytics', {
        type: 'idle',
        time: diff,
        save: false,
      });
    }
  }

  start() {
    this.lastEventTS = new Date().getTime();
    this.bindListeners();
    this.setTimer();
  }

  stop() {
    this.unbindListeners();
    this.unsetTimer();
  }
}
